/* name obj array for skills icons for the Project cards. */
import react from "../../images/skill-icons/react.svg";
import illustrator from "../../images/skill-icons/Ai.svg";
import css from "../../images/skill-icons/css.svg";
import html5 from "../../images/skill-icons/html5.svg";
import java from "../../images/skill-icons/java.svg";
import photoshop from "../../images/skill-icons/ps.svg";
import javascript from "../../images/skill-icons/javascript.svg";
import nodejs from "../../images/skill-icons/nodejs.svg";
import mongodb from "../../images/skill-icons/mongodb.svg";
import android from "../../images/skill-icons/android.svg";

export default
[
    {name: 'react', obj: react},
    {name: 'illustrator', obj: illustrator},
    {name: 'css', obj: css},
    {name: 'html5', obj: html5},
    {name: 'java', obj: java},
    {name: 'photoshop', obj: photoshop},
    {name: 'javascript', obj: javascript},
    {name: 'nodejs', obj: nodejs},
    {name: 'mongodb', obj: mongodb},
    {name: 'android', obj: android}
];